export default __webpack_public_path__ + "072392983443a703b4c97c1119201828.svg";